import { render } from "./PublicMedia.vue?vue&type=template&id=48a91bac"
import script from "./PublicMedia.vue?vue&type=script&lang=js"
export * from "./PublicMedia.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__